<ng-container *ngIf="isData; else emptyState">
  <ng-content></ng-content>
</ng-container>
<ng-template #emptyState>
  <div class="h-100 w-100 d-flex align-items-center justify-content-center bg-white">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <img class="image" [src]="imgPath" />
      <div class="mt-4 semibold title">
        {{ heading }}
      </div>
      <p *ngIf="description" class="mt-2 description" [innerHTML]="description"></p>
      <button *ngIf="addRoute" type="button" class="btn btn-primary btn-add mt-2" [routerLink]="addRoute">
        {{ 'common.buttons.add' | translate }}
      </button>
    </div>
  </div>
</ng-template>
